import Api from "@/services/Api";

const GuiMediaStore = {
  namespaced: true,
  state: {
    list1: {
      content: [],
      pageable: {
        pageSize: 20,
        pageNumber: 0,
        offset: 0,
        paged: true
      },
      totalElements: 0
    },
    ctgs: []
  },
  getters: {
    LIST: state => {
      return state.list1;
    },
    CTGS: state => {
      return state.ctgs;
    }
  },
  mutations: {
    SET_LIST: (state, pld) => {
      if (pld != null) state.list1 = pld;
    },
    ADD: (state, pld) => {
      state.list1.content.push(pld);
    },
    UPD: (state, pld) => {
      let fi2 = state.list1.content.findIndex(x => x.id == pld.id);
      if (fi2 >= 0) state.list1.content.splice(fi2, 1, pld);
    },
    DEL_ITEMS: (state, pld) => {
      state.list1.content = state.list1.content.filter(
        itm => pld.items.indexOf(itm.id) < 0
      );
    },
    DEL: (state, id) => {
      state.list1.content = state.list1.content.filter(itm => itm.id != id);
    },
    SET_CTGS: (state, pld) => {
      state.ctgs = pld;
    },
    ADD_CTG: (state, pld) => {
      let fi2 = state.ctgs.content.findIndex(x => x.id == pld.id);
      if (fi2 >= 0) state.ctgs.content.splice(fi2, 1, pld);
      else state.ctgs.push(pld);
    },
    DEL_CTG: (state, id) => {
      state.ctgs = state.ctgs.filter(itm => itm.id != id);
    }
  },
  actions: {
    GET_CTGS: async context => {
      let { data } = await Api().get("/media/ctg");
      context.commit("SET_CTGS", data);
    },
    // ADD_CTG: async (context, pld) => {
    //   if (plt == null) return;
    //   let cn = pld.trim();
    //   if (cn.length < 1) return;
    //   // try {
    //   let { data } = await Api().post("/media/ctg", {
    //     name: cn
    //   });
    //   context.commit("ADD_CTG", data);
    //   // } catch (e) {
    //   //   this.ctgNew = "";
    //   // }
    // },
    LIST_PG: async (context, pld) => {
      let { data } = await Api().get(
        "/media?page=" + pld.page + "&size=" + pld.size
      );
      context.commit("SET_LIST", data);
    },
    ADD: async (context, pld) => {
      let { data } = await Api().post("/media", pld);
      if (data && data.hasOwnProperty("name") && data.name == pld.name) {
        context.commit("ADD", data);
      } else {
        context.commit("ADD", pld);
      }
    },
    UPD: async (context, pld) => {
      let { data } = await Api().put("/media", pld);
      context.commit("UPD", data);
    },
    DEL_ITEMS: async (context, pld) => {
      let { data } = await Api().post("/media/multiDel", pld.items);
      context.commit("DEL_ITEMS", pld);
      console.log(
        "DEL_ITEMS commited pld.items=" + pld.items + "; data=" + data
      );
    },
    DEL: async (context, pld) => {
      let { data } = await Api().delete("/media/" + pld.id);
      context.commit("DEL", pld.id);
      console.log("DEL commited pld.id=" + pld.id + "; data=" + data);
    }
  }
};

export default GuiMediaStore;
